import React from "react";
import PropTypes from "prop-types";

import { MyDraggable as Draggable } from "../components/Core";
import HoverBar from "../components/HoverBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container, Row, Col } from "reactstrap";
import fbImage from "../../img/fbImage.png";
import { generateStyle, l, setOverLay } from "../functions";
import Icon from "../components/Icons";
import isEqual from "lodash/isEqual";
class FBCheckbox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  shouldComponentUpdate(nextProp, nextState) {
    const currentPayload = this.props?.payload;
    const nextPayload = nextProp?.payload;

    // console.log(JSON.stringify(currentPayload) === JSON.stringify(nextPayload));
    if (isEqual(currentPayload, nextPayload)) {
      return false;
    }
    // console.log("re-render");
    return true;
  }

  _initCheckbox = () => {
    let { payload } = this.props || { payload: [] };

    if (payload === null) payload = this.props.options.payload;

    const cssSettings = generateStyle(payload, "container");
    const cssAlignment = generateStyle(payload, "alignment");

    return (
      <Container fluid={payload.fullContainer} style={cssSettings}>
        {setOverLay(payload)}
        <Row>
          <Col xs={12} className="fullcol fb-checkbox">
            <div style={cssAlignment}>
              <img src={fbImage} alt="Facebook checkbox" />
            </div>
          </Col>
        </Row>
      </Container>
    );
  };

  render() {
    const {
      dropzoneID,
      parentID,
      showBasicContent,
      showPreview,
      id,
      dropzoneProps,
      payload,
      options,
      ...rest
    } = this.props;

    if (showBasicContent) {
      return (
        <Draggable {...this.props} side={true}>
          <span className="dragger">
            {(Array.isArray(rest.icon) && (
              <FontAwesomeIcon icon={rest.icon} />
            )) || <Icon icon={rest.icon} />}
            <span>{l(rest.name)}</span>
          </span>
        </Draggable>
      );
    }

    if (showPreview) {
      return <div>{this._initCheckbox()}</div>;
    }

    return (
      <Draggable {...this.props} minify={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          element={{ id, dropzoneID, parentID, payload }}
        />
        {this._initCheckbox()}
      </Draggable>
    );
  }
}

FBCheckbox.propTypes = {
  id: PropTypes.string.isRequired,
  showBasicContent: PropTypes.bool.isRequired,
};

export default FBCheckbox;
